const isProduction = process.env.NODE_ENV === 'production'
const isSentryAvailable = window.Sentry
  && window.Sentry.Integrations
  && typeof window.Sentry.init === 'function'
  && typeof window.Sentry.Integrations.Angular == 'function'

const FILE_TYPE_ASSIGNMENT = 'assignment'
const FILE_TYPE_RESUME = 'resume'

const QUESTION_TYPE_MULTIPLE_CHOICE = 'multiple-choice'
const QUESTION_TYPE_FILE = 'file'

function isHomerunError(event) {
  const frames = (event
      && event.exception
      && event.exception.values
      && event.exception.values[0]
      && event.exception.values[0].stacktrace
      && event.exception.values[0].stacktrace.frames) || []

  for (const index in frames) {
    const filename = frames[index].filename
    if (filename && filename.indexOf('/apply-form/v3/main.js') !== -1) {
      return true
    }
  }

  return false
}

function processXHRError(xhr) {
  var data = xhr.responseText
  if (data && data[0] === '<') {
    var parser = new DOMParser();
    var xml = parser.parseFromString(data, "text/xml");
    return xml.getElementsByTagName('Error')[0].getElementsByTagName('Message')[0].textContent
  }

  return 'Error uploading file'
}

isSentryAvailable && Sentry.init({
  dsn: process.env.MIX_SENTRY_DSN,
  release: process.env.MIX_SENTRY_RELEASE_TAG,
  integrations: [new Sentry.Integrations.Angular()],
  ignoreErrors: [
    /NS_ERROR_FAILURE/,
    /NS_ERROR_FILE_CORRUPTED/,
    /fbq/,
    /try again later/,
    /Network Error/,
    /SecurityError: Blocked a frame/,
    /ResizeObserver loop completed with undelivered notifications/,
    /ResizeObserver loop limit exceeded/,
    /LP_explicit_ignored/,
    /popupClass/,
    /Forbidden/,
    /document\.forms/,
    / not found/,
    /Too Many Requests/,
    // Requests canceled by the browser (no internet connection, extenstions, etc)
    // or cancelled by us using axios cancel tokens.
    /Request aborted/,
    /timeout of 0ms exceeded/,
  ],
  beforeSend(event) {
    if (isProduction && isHomerunError(event)) return event

    return null
  },
})

const angularDeps = ['ngSanitize']
if (isSentryAvailable) {
  angularDeps.push('ngSentry')
}

var ApplyForm
angular
  .module('apply-form', angularDeps)

  .service('Utils', function() {
    this.nl2br = function(text) {
      if (!angular.isUndefined(text) && text !== null) {
        text = text.replace(/\n/g, '<br />')
        return text.split('&#10;').join('<br />')
      }
    }
  })

  .service('FileUpload', ['$http', '$q', function($http, $q) {
    let activeUploads = 0

    this.activeUploads = function() {
      return activeUploads
    }

    this.uploadImage = function(file, outerCallback) {
      activeUploads++

      const fd = new FormData()
      fd.append('file', file)

      $http
        .post(window.location.pathname + '/image-upload', fd, {
          // angular.identity prevents Angular to do anything on our data (like serializing it).
          transformRequest: angular.identity,
          headers: {
            // The $http service will automatically add application/json as content type
            'Content-Type': undefined
          },
        })
        .then(function({ data }) {
          activeUploads--
          outerCallback(null, data)
        })
        .catch(function({ data }) {
          activeUploads--
          const message = data && data.message || "We couldn't upload the profile picture, please try again."
          outerCallback(new Error(message))
        })
    }

    this.uploadFile = function(file, outerCallback) {
      if (file.size > 25 * 1024 * 1024) {
        return outerCallback(new Error('The file is too large (max 25 MB.)'))
      }
      activeUploads++

      const params = {
        name: file.name,
        mime: file.type,
        size: file.size
      }

      const query = new URLSearchParams(window.location.search)
      if (query.has('token')) {
        params.token = query.get('token')
      }

      $http
          .get(window.location.pathname + '/upload-link', {
            headers: {
              'Accept': 'application/json',
            },
            params: params,
          })
          .then(function({ data }) {
            if (!data || !data.data || !data.data.upload_inputs) {
              outerCallback(new Error("Error setting up the upload"))
            }

            const deferred = $q.defer()
            const fd = new FormData()

            for (let key in data.data.upload_inputs) {
              fd.append(key, data.data.upload_inputs[key])
            }
            fd.append('Content-Type', file.type)
            // Actual file has to be appended last.
            fd.append('file', file)

            const xhr = new XMLHttpRequest()
            xhr.open('POST', data.data.upload_attributes.action, true)
            xhr.send(fd)

            xhr.onload = function() {
              activeUploads--
              if (this.status === 204) {
                outerCallback(null, {
                  data: data.data,
                })
                deferred.resolve(xhr)
              } else {
                const error = new Error(processXHRError(xhr))
                outerCallback(error)
                isSentryAvailable && Sentry.captureException(error)
                deferred.reject(xhr)
              }
            }

            xhr.onerror = function() {
              const error = new Error(processXHRError(xhr))
              isSentryAvailable && Sentry.captureException(error)

              // The browser blocked the file upload to S3,
              // could be a CORS issue, adblockers, etc
              if (xhr.status === 0) {
                return fallbackFileUpload(fd, xhr, deferred, outerCallback)
              }

              activeUploads--

              outerCallback(error)
              deferred.reject(xhr)
            }

            return deferred.promise
          })
          .catch(function (error) {
            activeUploads--
            if (error.status === 400 && error.data && error.data.details) {
              const message = error.data.details.map(detail => detail.message).join(', ')
              return outerCallback(new Error(message))
            }
          })
    }

    this.cancelUpload = function() {
      activeUploads--
    }

    this.triggerDelayedCanceled = function() {
      // This method is called when a file upload is completed while the user has
      // already canceled (removed) the file (and activeUploads has decreased by 1).
      activeUploads++
    }

    function fallbackFileUpload(fd, xhr, deferred, outerCallback) {
      $http
        .post(window.location.pathname + '/upload', fd, {
          transformRequest: angular.identity,
          headers: {
            'Content-Type': undefined
          },
        })
        .then(function({ data }) {
          activeUploads--
          outerCallback(null, data)
          deferred.resolve(xhr)
        })
        .catch(function({ data }) {
          activeUploads--
          const message = data && data.message || "We couldn't upload the file, please try again."
          outerCallback(new Error(message))
          deferred.reject(xhr)
        })
    }
  }])

  .filter('nl2br', ['Utils', function(Utils) {
    return Utils.nl2br
  }])

  .filter('validLink', function() {
    return function(link, type) {
      if (angular.isUndefined(link)) {
        return
      }

      switch (type) {
        case 'facebook':
          link = link.indexOf('facebook.com/') > -1 ? link : 'facebook.com/' + link
          break
        case 'twitter':
          link = link.indexOf('twitter.com/') > -1 || link.indexOf('x.com/') > -1 ? link : 'x.com/' + link
          break
        case 'linkedin':
          link = link.indexOf('linkedin.com/') > -1 ? link : 'linkedin.com/in/' + link
          break
        case 'github':
          link = link.indexOf('github.com/') > -1 ? link : ('github.com/' + link)
          break
      }

      link =
        link.indexOf('http://') === 0 || link.indexOf('https://') === 0 ? link : 'https://' + link

      return link
    }
  })

  .filter('age', function() {
    return function(dateString) {
      var today, birthDate, age, m

      if (angular.isUndefined(dateString)) {
        return
      }

      today = new Date()
      birthDate = new Date(dateString.replace(/-/g, '/').split('/').reverse().join('/'))
      age = today.getFullYear() - birthDate.getFullYear()
      m = today.getMonth() - birthDate.getMonth()

      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--
      }
      return isNaN(age) ? '' : age
    }
  })

  .directive('ngInitial', ['$parse', function($parse) {
    return {
      restrict: 'A',
      compile: function($element, $attrs) {
        var initialValue = $attrs.value || $element.val() || $element.text()
        return {
          pre: function($scope, $element, $attrs) {
            $parse($attrs.ngModel).assign($scope, initialValue)
          },
        }
      },
    }
  }])

  .directive('fileDrop', function() {
    return {
      restrict: 'A',
      scope: {
        fileDrop: '&',
      },
      link: function($scope, element, attrs) {
        element[0].addEventListener(
          'dragover',
          function(e) {
            e.preventDefault()
            e.stopPropagation()
            e.dataTransfer.dropEffect = 'move'
            return false
          },
          false
        )

        element[0].addEventListener(
          'drop',
          function(e) {
            e.preventDefault()
            e.stopPropagation()

            if (e.dataTransfer.files.length > 0) {
              $scope.fileDrop({
                files: e.dataTransfer.files
              })
            }
            return false
          },
          false
        )
      },
    }
  })

  // todo @ fileDrop and fileChange : check for IE9 and Accept attribute:
  // https://github.com/angular/angular.js/issues/1375#issuecomment-28570867

  .directive('fileChange', ['$compile', function($compile) {
    return {
      restrict: 'A',
      scope: {
        fileChange: '&',
      },
      link: function($scope, element, attrs) {
        element.bind('change', function() {
          var parent
          $scope.fileChange({
            files: element[0].files
          })

          parent = element.parent()
          angular.element(document.body).append('<form id="resetform"></form>')
          angular.element(document.querySelector('#resetform')).append(element).get(0).reset()
          parent.append(element)
          angular.element(document.querySelector('#resetform')).remove()
        })
      },
    }
  }])

  .directive('triggerFileInput', function () {
    return function (scope, element, attrs) {
      element.bind('keydown keypress', function (event) {
        const key = typeof event.which === "undefined" ? event.keyCode : event.which
        // Trigger upload on space & enter
        if(key === 13 || key === 32) {
          event.preventDefault()
          scope.$apply(function () {
            $(`#${attrs.ariaControls}`).click()
          })
        }
      })
    }
  })

  .controller('ApplyController', ['$scope', '$window', '$filter', '$http', '$log', 'FileUpload', 'Utils', function($scope, $window, $filter, $http, $log, FileUpload, Utils) {
    var ready = false
    let uploadIndex = 0

    $scope.availableQuestions = []
    $scope.formData = {
      files: [],
      questions: {},
    }

    angular.element(document).ready(function() {
      const existingData = ApplyForm.Storage.getData()
      if (existingData != null) {
        try {
          const storageData = JSON.parse(existingData)
          storageData.files = Array.isArray(storageData.files) ? storageData.files : []

          // Filter out questions that may have been deleted in the meantime
          // as the applicant can not change/access them anymore
          storageData.questions = $scope.availableQuestions.reduce((filteredAnswers, question) => {
            let previousAnswer = storageData.questions[question.id] || $scope.formData.questions[question.id]
            if (question.type === QUESTION_TYPE_MULTIPLE_CHOICE) {
              const options = question.localizations[0].options
              const multiSelect = question.settings && question.settings.multiple_selection

              // Change answer type when question changed between multi and single select
              if (Array.isArray(previousAnswer) && !multiSelect) {
                previousAnswer = previousAnswer[0] || ''
              } else if (typeof previousAnswer === 'string' && multiSelect) {
                previousAnswer = [previousAnswer]
              }

              // Make sure no old answers which dont exist anymore stay stored
              if (multiSelect) {
                previousAnswer = previousAnswer.filter((answer) => options.includes(answer))
              } else {
                previousAnswer = options.includes(previousAnswer) ? previousAnswer : '';
              }
            } else if (question.type === QUESTION_TYPE_FILE) {
              const multiSelect = question.settings && question.settings.multiple_selection
              if (!multiSelect) {
                // Keep only first file
                const fileAnswer = Array.isArray(previousAnswer) ? previousAnswer : []

                // Filter the other files
                const filesToRemove = fileAnswer.splice(1)
                storageData.files = storageData.files.filter(function filterFiles(file) {
                  return !filesToRemove.find((f) => f.hash === file.hash && f.id === file.id)
                })

                previousAnswer = fileAnswer
              }
            }

            filteredAnswers[question.id] = previousAnswer
            return filteredAnswers
          }, {});

          storageData.files = storageData.files || []
          uploadIndex = storageData.files.reduce((highest, file) => {
            return file.index >= highest ? file.index + 1 : highest
          }, 0)

          $scope.formData = storageData
        } catch (error) {
          if (!isProduction) {
            console.error(error)
          }
          isSentryAvailable && Sentry.captureException(error)
        }
      }
      ready = true

      $scope.$apply()
    })

    /**
     * Adds an answer for single select questions.
     */
    function singleSelectAnswer(question, answer) {
      const questions = $scope.formData.questions
      if (question.is_mandatory) {
        // Answers to mandatory questions can not be removed
        questions[question.id] = answer
        return
      }

      questions[question.id] = questions[question.id] === answer ? '' : answer
      return

    }

    /**
     * Adds an answer for questions that allow multiple selection.
     */
    function multiSelectAnswer(question, answer) {
      const questions = $scope.formData.questions
      const answers = Array.isArray(questions[question.id]) ? questions[question.id] : []
      const indexOfAnswer = answers.indexOf(answer)

      // Don't remove the only answer if mandatory
      if (question.is_mandatory && answers.length === 1 && indexOfAnswer === 0) {
        return
      }

      if (indexOfAnswer >= 0) {
        answers.splice(indexOfAnswer, 1)
      } else {
        answers.push(answer)
      }

      questions[question.id] = answers
    }

    /**
     * Adds a file to the answers for the appropriate question. In case only a single
     * file can be selected it will also clear the previous answers.
     */
    function addFileAnswer(fileData) {
      const questionId = Number.parseInt(fileData.type.split('-')[1], 10)
      const question = $scope.availableQuestions.find((question) => question.id === questionId)
      const questions = $scope.formData.questions

      let newAnswers
      const previousAnswers = Array.isArray(questions[questionId]) ? questions[questionId] : []

      if (question.settings && question.settings.multiple_selection) {
        newAnswers = previousAnswers.concat(fileData)
      } else {
        // When only a single file is allowed we should remove the previous file from the general file uploads
        previousAnswers.forEach((fileData) => {
          const index = $scope.formData.files.findIndex((file) => file.id === fileData.id && file.hash === fileData.hash)
          if (index < 0) {
            return
          }
          $scope.formData.files.splice(index, 1)
        })
        newAnswers = [fileData]
      }

      questions[questionId] = newAnswers
    }

    /**
     * Takes a file that was removed from the general file uploads and removes it
     * from the question answers as well.
     */
    function removeFileAnswer(fileData) {
      const questionId = Number.parseInt(fileData.type.split('-')[1], 10)
      const answers = $scope.formData.questions[questionId]

      const fileIndex = answers.findIndex((file) => file.hash === fileData.hash && file.id === fileData.id)
      if (fileIndex < 0) {
        return
      }
      answers.splice(fileIndex, 1)
    }

    $scope.selectAnswer = function(questionId, answer) {
      const question = $scope.availableQuestions.find((question) => question.id === questionId)

      if (question.settings && question.settings.multiple_selection) {
        multiSelectAnswer(question, answer)
        return
      }
      singleSelectAnswer(question, answer)
    }

    let originalFormData = JSON.parse(JSON.stringify($scope.formData))

    $scope.uploading_photo = false
    $scope.uploadPhoto = function(files) {
      const [profilePicture] = files
      $scope.candidatePhotoError = null

      if (profilePicture.size > 2 * 1024 * 1024) {
        $scope.$apply(function() {
          $scope.candidatePhotoError = 'The profile picture is too large (max 2 MB.)'
        })
        return
      }

      $scope.uploading_photo = true
      FileUpload.uploadImage(profilePicture, function(err, { data } = {}) {
        $scope.uploading_photo = false

        if (err) {
          $scope.$apply(function() {
            $scope.candidatePhotoError = err.message
          })
          return
        }

        $scope.formData.photo = data.fileurl
        $scope.formData.real_photo = data.filename
        $scope.formData.real_photos = data.result_set
      })
    }

    $scope.isAnswerSelected = function(questionId, answer) {
      const question = $scope.availableQuestions.find((question) => question.id === questionId)
      const selection = $scope.formData.questions[questionId]

      if (question.settings && question.settings.multiple_selection) {
        return Array.isArray(selection) && selection.includes(answer)
      }

      return selection === answer
    }

    $scope.isAnswered = function(questionId) {
      const answer = $scope.formData.questions[questionId]
      return !!(answer && answer.length)
    }

    $scope.hasFiles = function(type) {
      return !!$scope.formData.files.filter((file) => file.type === type).length
    }

    // @TODO errors
    $scope.uploadError = {
      [FILE_TYPE_ASSIGNMENT]: null,
      [FILE_TYPE_RESUME]: null,
    }

    $scope.openFilePicker = function(fileInputId) {
      $(`#${fileInputId}`).click()
    }

    $scope.uploadFile = function(files, type, singleFile) {
      $scope.uploadError[type] = null

      const isFileQuestion = type.startsWith('question-')
      if (isFileQuestion) {
        const questionId = Number.parseInt(type.split('-')[1], 10)
        const question = $scope.availableQuestions.find((question) => question.id === questionId)
        const nOriginalFiles = files.length
        if (question && question.settings.pdf_only) {
          files = [...files].filter((file) => file.type === 'application/pdf')
        }
        if (nOriginalFiles !== files.length) {
          $scope.uploadError[type] = 'Only PDF files are allowed'
        }
      }

      if (files.length === 0) {
        $scope.$apply()
        return
      }

      const max = singleFile ? 1 : files.length
      for (let i = 0; i < max; i++) {
        const fileData = {
          name: files[i].name,
          type: type,
          index: uploadIndex++,
          status: 'processing',
        }
        $scope.formData.files.push(fileData)

        FileUpload.uploadFile(files[i], function(err, res) {
          const alreadyCanceled = $scope.formData.files.findIndex((file) => file === fileData) < 0
          if (alreadyCanceled) {
            FileUpload.triggerDelayedCanceled()
            return
          }

          if (err) {
            $scope.uploadError[type] = err.message
            fileData.status = 'error'
            return
          }

          fileData.id = res.data.id
          fileData.hash = res.data.hash
          fileData.status = 'success'

          if (isFileQuestion) {
            addFileAnswer(fileData)
          }
        })
      }

      $scope.$apply()
    }

    $scope.removeFile = function(fileToRemove) {
      for (let i = 0; i < $scope.formData.files.length; i++) {
        const file = $scope.formData.files[i]
        if (file.index !== fileToRemove.index) {
          continue
        }

        if (file.status === 'processing') {
          FileUpload.cancelUpload()
        } else if (file.status === 'error') {
          $scope.uploadError[file.type] = null
        }
        $scope.formData.files.splice(i, 1)

        if (file.type.indexOf('question-') === 0) {
          removeFileAnswer(file)
        }
        break
      }
    }

    $scope.submitting = false
    $scope.submitted = false

    $scope.apply = function() {
      var $list, $target, tabIndex
      if (FileUpload.activeUploads() > 0) {
        $scope.errors = [{
          error: 'Please wait until all files have been uploaded and try again.',
        }, ]
        return
      }

      // Why do we have an extra check after activeUploads conditional?
      // When a file upload is in progress (and stored in local storage)
      // and the user refreshes the page or navigates away, the moment
      // the user comes back to the page the file is still in progress in the UI
      // but the form submission is not stopped because activeUploads counter being 0.
      var pendingFiles = $scope.formData.files.reduce(function countFiles(acc, file) {
        return file.status !== 'success' ? ++acc : acc
      }, 0)

      if (pendingFiles > 0) {
        $scope.errors = [{
          error: 'Some files were not uploaded correctly. Please upload them again.',
        }, ]
        return
      }

      if ($scope.submitting) {
        return
      }

      $scope.submitting = true

      if ($window.innerWidth > 760) {
        setTimeout(function() {
          $('body,html').scrollTop(100)
          $('body,html').animate({
            scrollTop: 0
          }, 200)
        }, 420)
      }

      originalFormData = JSON.parse(JSON.stringify($scope.formData))

      if ($scope.formData.date_of_birth) {
        $scope.formData.date_of_birth = $scope.formData.date_of_birth
          .replace(/\//g, '-')
          .split('-')
          .reverse()
          .join('-')
      }

      $list = $('ul.nav-tabs')
      $target = $('[data-tabcontent="' + $list.attr('data-tabsnav') + '"]')
      tabIndex = $list.find('li').last().index()

      function errorCallback(res) {
        ApplyForm.Tabs.switchTab($list, $target, 0, false, false)

        setTimeout(function() {
          $scope.submitting = false
          $scope.$apply()
        }, 420)

        $scope.errors = []
        $scope.trialLimitError = false

        const inputs = document.querySelectorAll('[name]')
        inputs.forEach((input) => {
          angular.element(input).removeClass('error')
        })

        if (res && typeof res.message === 'string') {
          const limits = ['too_many_candidates', 'too_many_invites', 'too_many_emails']
          if (limits.includes(res.message)) {
            $scope.trialLimitError = true
            return
          }

          $scope.errors.push({
            label: 'exception',
            error: res.message,
          })
          return
        }

        var x
        for (x in res.message) {
          if (!$filter('filter')($scope.errors, {
              error: res.message[x][0]
            }, true).length) {
            $scope.errors.push({
              label: x,
              error: res.message[x][0],
            })
          }
          angular.element(document.querySelector('[name="' + x + '"]')).addClass('error')
        }
      }

      // As question files are also stored in the question answers we can remove them before uploading
      const payload = { ...$scope.formData }
      payload.files = payload.files.filter(function filterQuestionFiles(file) {
        return file.type === FILE_TYPE_ASSIGNMENT || file.type === FILE_TYPE_RESUME
      })

      // Add SPAM protection fields
      const spamCheck = $('#homerun_required')
      const spamValidForm = $('#homerun_valid_form')
      payload[spamCheck.attr('name')] = spamCheck.val()
      payload[spamValidForm.attr('name')] = spamValidForm.val()

      $http
        .post('', payload)
        .then(function({
          data: res
        }) {
          if (!angular.isUndefined(res.message)) {
            return errorCallback(res)
          }

          ApplyForm.Tabs.switchTab($list, $target, tabIndex, false, true)

          setTimeout(function() {
            $scope.submitting = false
            $scope.submitted = true
            $scope.$apply()
          }, 420)

          ApplyForm.Storage.clearData()

          // Google Tag Manager
          dataLayer.push({
            event: 'onlineSollicitatie'
          })

          const homerunPrivacySettings = window.homerunPrivacySettings || {}

          // Custom GA4 events
          const ga4Ids = homerunPrivacySettings.customGA4Ids
          for (let i in ga4Ids) {
            dataLayer.push('event', 'candidate_applied', { 'send_to': ga4Ids[i] })
          }

          // Apply with LinkedIn conversion
          var liEl = document.querySelector('[type="IN/AwliWidget"]')
          if (liEl !== null) {
            liEl.setAttribute('data-mode', 'CONVERSION')
            var script = document.createElement('script')
            script.type = 'text/javascript'
            script.src = 'https://www.linkedin.com/mjobs/awli/awliWidget'
            document.body.appendChild(script)
          }

          // Custom callback
          if (typeof window.customCallback === 'function') {
            try {
              customCallback()
            } catch(error) {
              $log.error(error)
            }
          }

          // Clear data
          $scope.formData = {
            files: [],
            questions: {}
          }
          $scope.errors = []
          uploadIndex = 0
        })
        .catch(function({
          data: res
        }) {
          errorCallback(res)
        })
    }

    $scope.$watch(
      'formData',
      function() {
        if (!ready) {
          return
        }

        function removeErrorLabel(name) {
          $scope.errors = $filter('filter')($scope.errors, {
            label: '!' + name,
          }, true)
          angular.element(document.querySelector(`[name="${name}"]`)).removeClass('error')
        }

        for (let field in $scope.formData) {
          if (field === 'questions') {
            for (let questionId in $scope.formData.questions) {
              const currentAnswer = JSON.stringify($scope.formData.questions[questionId])
              const originalAnswer = JSON.stringify(originalFormData.questions[questionId])

              if (currentAnswer !== originalAnswer) {
                removeErrorLabel(`questions[${questionId}]`)
              }
            }
          } else if ($scope.formData[field] !== originalFormData[field]) {
            removeErrorLabel(field)
          }
        }

        const json = JSON.stringify($scope.formData)
        ApplyForm.Storage.setData(json)

        originalFormData = JSON.parse(json)
      },
      true
    )
  }])

ApplyForm = window.ApplyForm || {}
ApplyForm.Form = {}
ApplyForm.Tabs = {}
ApplyForm.Storage = {}

;
(function(Storage) {
  const STORAGE_KEY = `${window.location.origin}${window.location.pathname}`

  function isLocalStorageAvailable() {
    try {
      const keyValue = '__storage_test__';
      window.localStorage.setItem(keyValue, keyValue);
      window.localStorage.removeItem(keyValue);
      return true;
    } catch (e) {
      return (window.localStorage && window.localStorage.length !== 0) &&
        e instanceof DOMException &&
        (
          // everything except Firefox
          e.code === 22 ||
          // Firefox
          e.code === 1014 ||
          // test name field too, because code might not be present
          // everything except Firefox
          e.name === 'QuotaExceededError' ||
          // Firefox
          e.name === 'NS_ERROR_DOM_QUOTA_REACHED'
        )
    }
  }
  const localStorageAvailable = isLocalStorageAvailable()

  Storage.getData = function getLocalStorageData() {
    if (!localStorageAvailable) {
      return null
    }
    return window.localStorage.getItem(STORAGE_KEY)
  }

  Storage.setData = function setLocalStorageData(data) {
    if (!localStorageAvailable) {
      return
    }
    window.localStorage.setItem(STORAGE_KEY, data)
  }

  Storage.clearData = function clearLocalStorageData() {
    if (!localStorageAvailable) {
      return
    }
    window.localStorage.removeItem(STORAGE_KEY)
  }

  Storage.hasData = function hasLocalStorageData() {
    return this.getData() !== null
  }
})(ApplyForm.Storage)

/*
 * Form functionality
 */
;
(function(Form) {
  Form.init = function() {
    // Change specific section of the form
    $(document).on('click', '.btn-change', function() {
      var $this = $(this)
      var $list = $(
        '[data-tabsnav="' + $this.closest('.tab-content').attr('data-tabcontent') + '"]'
      )
      var $target = $this.closest('.tab-content')
      var int_gotoTab = Number.parseInt($this.attr('data-gototab'), 10)
      var gotoSection = $this.attr('data-scrolltosection')
      var doScroll = gotoSection === 'top'

      ApplyForm.Tabs.switchTab($list, $target, int_gotoTab, doScroll, true, function() {
        if (gotoSection !== 'top') {
          $('html,body').scrollTop($('[data-section="' + gotoSection + '"]').offset().top - 30)
        }
      })
    })
  }
})(ApplyForm.Form)

/*
 * Tabs
 */
;
(function(Tabs) {
  const TAB_INDEX_PARAM = 'step'

  function getUrlTabIndex() {
    const query = window.location.search.substring(1);
    const params = query.split('&');
    for (let i = 0; i < params.length; i++) {
        const [name, value] = params[i].split('=');
        if (decodeURIComponent(name) == TAB_INDEX_PARAM) {
          const step = Number.parseInt(value, 10);
          if (!Number.isNaN(step)) {
            return step - 1
          }
        }
    }
    return null
  }

  function createQueryParams(tabIndex) {
    const query = window.location.search.substring(1);
    const params = query.split('&').filter(function(pair) {
        const [name] = pair.split('=');
        return decodeURIComponent(name) !== TAB_INDEX_PARAM
    }, [])
    if (tabIndex != null) {
      const step = tabIndex + 1
      params.push(`${encodeURIComponent(TAB_INDEX_PARAM)}=${encodeURIComponent(step)}`)
    }

    return params.join('&')
  }

  function setUrlTabIndex(tabIndex, pushHistory) {
    const url = `${window.location.origin}${window.location.pathname}?${createQueryParams(tabIndex)}`
    const stateName = `${window.document.title} - step ${tabIndex + 1}`

    if (pushHistory) {
      window.history.pushState({}, stateName, url)
    } else {
      window.history.replaceState({}, stateName, url)
    }
  }

  function restoreTabIndex() {
    const previousTabIndex = getUrlTabIndex()

    const $list = $('ul.nav-tabs')
    const tabCount = $list.find('li').length
    if (previousTabIndex == null || previousTabIndex >= (tabCount - 1)) {
      setUrlTabIndex(0, false)
      return;
    }

    const $target = $('[data-tabcontent="' + $list.attr('data-tabsnav') + '"]')
    ApplyForm.Tabs.switchTab($list, $target, previousTabIndex, false, false)
  }

  Tabs.init = function() {
    if (ApplyForm.Storage.hasData()) {
      restoreTabIndex()
    } else {
      setUrlTabIndex(0, false)
    }

    window.onpopstate = function(event) {
      const $body = $('body')
      // In case an applicant goes back in history after submitting clear & goto tab index 0
      if ($body.hasClass('done')) {
        $('body').removeClass('done')
        const $list = $('ul.nav-tabs')
        const $target = $('[data-tabcontent="' + $list.attr('data-tabsnav') + '"]')
        ApplyForm.Tabs.switchTab($list, $target, 0, false, false)
      } else {
        restoreTabIndex()
      }
    }

    $(document).on('click', '.nav-tabs a', function() {
      var $this = $(this)
      var $list = $this.closest('ul')
      var $target = $('[data-tabcontent="' + $list.attr('data-tabsnav') + '"]')
      var tabIndex = $this.parent().index()

      // if clicked = active -> do nothing
      if ($this.parent().hasClass('active')) {
        return
      }

      Tabs.switchTab($list, $target, tabIndex, false, true)
    })

    $(document).on('click', '.tab-control', function(e) {
      var $this = $(this)
      var $list = $('[data-tabsnav="' + $this.parent().attr('data-tabcontrols') + '"]')
      var $target = $('[data-tabcontent="' + $this.parent().attr('data-tabcontrols') + '"]')
      var tabIndex = Number.parseInt($this.attr('data-gotoindex'), 10)

      if (isNaN(tabIndex)) {
        return
      }

      e.preventDefault()

      Tabs.switchTab($list, $target, tabIndex, true, true)
    })
  }

  Tabs.switchTab = function($list, $target, tabIndex, doScroll, pushHistory, callback) {
    if (window.innerWidth < 761) {
      return
    }

    setUrlTabIndex(tabIndex, pushHistory)

    $list.find('li').removeClass('active').removeClass('done')
    $list.find('li:lt(' + tabIndex + ')').addClass('done')
    $list.find('li:eq(' + tabIndex + ')').addClass('active')

    $target.find('.tab-pane').addClass('inactive')

    $('.fill-bar i').css({
      width: ((tabIndex + 1) / $list.find('li').length) * 100 + '%',
    })

    setTimeout(function() {
      if (doScroll === true && $(window).scrollTop() > 60) {
        $('body,html').scrollTop(100)
        $('body,html').animate({
          scrollTop: 0
        }, 200)
      }

      $target.find('.tab-pane').removeClass('active')
      $target.find('.tab-pane:eq(' + tabIndex + ')').addClass('active')

      setTimeout(function() {
        $target.find('.tab-pane:eq(' + tabIndex + ')').removeClass('inactive')
        if (typeof callback === 'function') {
          callback()
        }
      }, 10)
    }, 420)
  }
})(ApplyForm.Tabs)

/*
 * Document ready
 */

$(function() {
  ApplyForm.Form.init()
  ApplyForm.Tabs.init()
})
